export default "__VITE_ASSET__dEhJCEkc__"